import AdvisorError from './AdvisorError';
class AdvisorURLError extends AdvisorError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('AdvisorURLError', ...args);
    }
}
export default AdvisorURLError;
